import { TraceableProcess, TrackingEvent } from "../../../services/analytics/model"

export class AppointmentStartedEvent implements TrackingEvent {
    public readonly action = 'Appointment Started'
    public readonly category = TraceableProcess.APPOINTMENT_SCHEDULING
    constructor (public readonly property_legal_id: string){}
  }